import script from "./SideForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SideForm.vue?vue&type=script&setup=true&lang=js"

import "./SideForm.vue?vue&type=style&index=0&id=270394d9&lang=less&scoped=true"

import exportComponent from "/Users/timetravel/code/energy-storage-intelligence/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-270394d9"]])

export default __exports__